import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';

export class DrawingPreview implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Drawing Preview';
  readonly apiRoute: string = CONFIG.apiRoutes.drawingPreview;

  mediaId: string;
  preview: string;
  lastModified: Date;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.mediaId = data.mediaId;
    this.preview = data.preview;
    this.lastModified = data.lastModified;
  }
}
